import useHookEndpoints from '~/components/SystemConfiguration/HookEndpoints/useHookEndpoints';
import useDataFetcher from '~/components/useDataFetcher';
import type { PostFnolHookBindingResponse } from '~/server_shared/openapi/data-contracts';

const getBindingUrl = (organizationId: number, incidentConfigurationId: number) =>
  `/sysconfig/api/v1/organizations/${organizationId}/incident_configurations/${incidentConfigurationId}/post_fnol_hook`;

const usePostFnolHookData = (organizationId: number, incidentConfigurationId: number) => {
  const { isLoading: isBindingLoading, data: binding } = useDataFetcher<PostFnolHookBindingResponse | null>(
    getBindingUrl(organizationId, incidentConfigurationId)
  );

  const { isLoading: isEndpointsLoading, data: endpoints } = useHookEndpoints(organizationId);

  return {
    binding: binding || null,
    endpoints: endpoints ?? [],
    isLoading: isBindingLoading || isEndpointsLoading,
    bindingUrl: getBindingUrl(organizationId, incidentConfigurationId),
  };
};

export default usePostFnolHookData;
